var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
export class SkuFieldBase {
  constructor(_data) {
    /**
     */
    __publicField(this, "Order");
    /**
     */
    __publicField(this, "OrderByField");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof SkuFieldBase
     */
    __publicField(this, "$type", "V1.ComplianceMasterData.SearchSku.SkuFieldBase");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      this.Order = SkuFieldBaseOrder[_data["Order"]];
      this.OrderByField = SkuFieldBaseOrderByField[_data["OrderByField"]];
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["$type"] = this.$type;
    _data["Order"] = SkuFieldBaseOrder[this.Order];
    _data["OrderByField"] = SkuFieldBaseOrderByField[this.OrderByField];
    return _data;
  }
}
export var SkuFieldBaseOrder = /* @__PURE__ */ ((SkuFieldBaseOrder2) => {
  SkuFieldBaseOrder2["Ascending"] = "Ascending";
  SkuFieldBaseOrder2["Descending"] = "Descending";
  return SkuFieldBaseOrder2;
})(SkuFieldBaseOrder || {});
export var SkuFieldBaseOrderByField = /* @__PURE__ */ ((SkuFieldBaseOrderByField2) => {
  SkuFieldBaseOrderByField2["Sku"] = "Sku";
  SkuFieldBaseOrderByField2["SellerEntityId"] = "SellerEntityId";
  SkuFieldBaseOrderByField2["CommodityCode"] = "CommodityCode";
  SkuFieldBaseOrderByField2["ItemIdentifier"] = "ItemIdentifier";
  SkuFieldBaseOrderByField2["Price"] = "Price";
  return SkuFieldBaseOrderByField2;
})(SkuFieldBaseOrderByField || {});
